export const MODAL_AND_DRAWERS_CONSTANTS: Record<string, number> = {
    initialOpacity: 0,
    animationOpacity: 0.8,
    exitOpacity: 0,
};
